import { createReducer, on } from '@ngrx/store';

import { logout } from '../../user-store/user-store.actions';

import * as RevenueActions from './revenue.actions';
import { IRevenueState, revenueInitialState } from './revenue.state';

export const dashboardRevenueStoreFeatureKey = 'dashboardRevenueStore';

export const reducer = createReducer(
  revenueInitialState,
  on(
    RevenueActions.load,
    (state): IRevenueState => ({
      ...state,
      isLoading: true,
    }),
  ),
  on(
    RevenueActions.loadSuccess,
    (state: IRevenueState, { payload: { params, data } }): IRevenueState => {
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          [params.start.getTime()]: {
            ...state.data[params.start.getTime()],
            [params.end.getTime()]: data,
          },
        },
      };
    },
  ),
  on(
    RevenueActions.loadFailure,
    (state): IRevenueState => ({
      ...state,
      isLoading: false,
    }),
  ),
  on(logout, RevenueActions.clear, (): IRevenueState => revenueInitialState),
);
